export default __webpack_public_path__ + "static/media/load.f71b5926.gif";